import axios from "axios";
import { push, ref, remove } from "firebase/database";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { database, storage } from "../../../firebase";
import { DeleteDemandBin } from "../../../redux/actions";
import Loader from "../Loader";
import { deleteObject, ref as sRef } from "firebase/storage";
const ModalApprove = ({ show, setShow, bin, id, removeFromList }) => {
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const handleAccept = async () => {
    setLoading(true);
    try {
      await push(ref(database, `bins/${bin.bin_type}`), {
        coords: bin.coords,
      });
      const imgRef = sRef(storage, `images/${id}`);
      deleteObject(imgRef);
      await remove(ref(database, `pending-demands/${id}`));
      await axios.post(`${process.env.REACT_APP_AMAZING_SERVER}/bin-accepted`, { email: bin.email });
      removeFromList(id);
      navigate("/check-bins");
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
    setShow(false);
  };

  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      {loading && <Loader />}
      <Modal.Header className="d-flex justify-content-center align-items-center">Προσθήκη Κάδου</Modal.Header>
      <Modal.Body className="d-flex justify-content-center align-items-center">
        Ο κάδος θα προστεθεί στην εφαρμογή
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-evenly align-items-center">
        <Button onClick={() => setShow(false)} variant="danger">
          Ακύρωση
        </Button>
        <Button onClick={handleAccept} variant="success">
          Επιβεβαίωση
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapDispatchToPros = (dispatch) => ({
  removeFromList: (value) => dispatch(DeleteDemandBin(value)),
});

export default connect(null, mapDispatchToPros)(ModalApprove);
